import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EmergencyEventBannerCardComponent } from './emergency-event-banner-card/emergency-event-banner-card.component';
import { SiteDetailCardComponent } from './site-detail-card/site-detail-card.component';

@NgModule({
    declarations: [EmergencyEventBannerCardComponent, SiteDetailCardComponent],
    imports: [CommonModule, SharedModule, FontAwesomeModule],
    exports: [EmergencyEventBannerCardComponent, SiteDetailCardComponent],
})
export class LandingModule {}
